// extracted by mini-css-extract-plugin
export default {"table":"Table_table__mdrGv","striped":"Table_striped__brUWr","fixed":"Table_fixed__Iuvkq"};